import { $ } from "@/plug/Axios";

export default {
  /**
   * 免试专升本-做题记录
   */
  degree_StudentExercise_commit: {
    /*
     * 交卷(返回练习id)
     * answers 答案 (array query required)
     * belongId 试卷id， paperId (integer query required)
     * exerciseTime 练习时间（秒） (integer query required)
     * subjectIds 题目id (array query required)
     * type 类型：章节作业，模拟测试，阶段小测 历年真题 (string query required)
     */
    post: (p, c) =>
      $.post("/api/cms/exemption/degree/StudentExercise/commit", p, c)
  },
  degree_StudentExercise_commitForEntry: {
    /*
     * 交卷-入门测试的(返回练习id)
     * answers 答案 (array query required)
     * exerciseTime 练习时间（秒） (integer query required)
     * paperId 试卷ID (integer query required)
     * subjectIds 题目id (array query required)
     * userId userId (integer query required)
     */
    post: (p, c) =>
      $.post("/api/cms/exemption/degree/StudentExercise/commitForEntry", p, c)
  },
  degree_StudentExercise_commitForSingle: {
    /*
     * 交卷(仅题库练习，单题模式)
     * answer 答案 (string query required)
     * belongId 试卷id， paperId (integer query required)
     * courseId 课程id (integer query required)
     * subjectId 题目id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/cms/exemption/degree/StudentExercise/commitForSingle", p, c)
  },
  degree_StudentExercise_exportForEntryExam: {
    /*
     * 导出入门测试
     */
    get: (p, c) =>
      $.get(
        "/api/cms/exemption/degree/StudentExercise/exportForEntryExam",
        p,
        c
      )
  },
  degree_StudentExercise_exportForHomework: {
    /*
     * 导出章节作业
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/StudentExercise/exportForHomework", p, c)
  },
  degree_StudentExercise_exportForMockExam: {
    /*
     * 导出模拟测试
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/StudentExercise/exportForMockExam", p, c)
  },
  degree_StudentExercise_exportForReal: {
    /*
     * 导出历年真题
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/StudentExercise/exportForReal", p, c)
  },
  degree_StudentExercise_exportForStageQuiz: {
    /*
     * 导出阶段小测
     */
    get: (p, c) =>
      $.get(
        "/api/cms/exemption/degree/StudentExercise/exportForStageQuiz",
        p,
        c
      )
  },
  degree_StudentExercise_exportForStore: {
    /*
     * 导出题库练习
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/StudentExercise/exportForStore", p, c)
  },
  degree_StudentExercise_listEntryExam: {
    /*
     * 学生入门测试列表
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/StudentExercise/listEntryExam", p, c)
  },
  degree_StudentExercise_listHomework: {
    /*
     * 学生章节作业列表
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/StudentExercise/listHomework", p, c)
  },
  degree_StudentExercise_listMockExam: {
    /*
     * 学生模拟测试列表
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/StudentExercise/listMockExam", p, c)
  },
  degree_StudentExercise_listReal: {
    /*
     * 学生历年真题列表
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/StudentExercise/listReal", p, c)
  },
  degree_StudentExercise_listStageQuiz: {
    /*
     * 学生阶段小测列表
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/StudentExercise/listStageQuiz", p, c)
  },
  degree_StudentExercise_listStore: {
    /*
     * 学生题库练习列表
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/StudentExercise/listStore", p, c)
  },
  degree_StudentExercise_read: {
    /*
     * 阅卷
     * id 练习id (integer query required)
     * scores 分数 (array query required)
     * subjectIds 题目id (array query required)
     */
    post: (p, c) =>
      $.post("/api/cms/exemption/degree/StudentExercise/read", p, c)
  },
  degree_StudentExercise_redo: {
    /*
     * 打回重做
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/cms/exemption/degree/StudentExercise/redo", p, c)
  },
  degree_app_getStudyMainInfo: {
    /*
     * 学习档案-基本信息
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/app/getStudyMainInfo", p, c)
  },
  degree_app_getStudyMainInfoByTeacher: {
    /*
     * 学习档案-基本信息(小程序班主任查看)
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/app/getStudyMainInfoByTeacher", p, c)
  },
  degree_app_listScoreByType: {
    /*
     * 学习档案-模考成绩
     * type 类型：模拟测试, 历年真题 (string query required)
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/app/listScoreByType", p, c)
  },
  degree_app_listScoreByTypeByTeacher: {
    /*
     * 学习档案-模考成绩(小程序班主任查看)
     * schoolRollId 合同编号 (integer query required)
     * type 类型：模拟测试, 历年真题 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/app/listScoreByTypeByTeacher", p, c)
  },
  degree_chapter: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * courseId 课程id (integer query )
     * id  (integer query )
     * name 大章名称 (string query )
     * sort 排序 (integer query )
     */
    post: (p, c) => $.post("/api/cms/exemption/degree/chapter", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/exemption/degree/chapter", p, c)
  },
  degree_chapter_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/chapter/list", p, c)
  },
  degree_chapter_listForClient: {
    /*
     * 免试专升本课程大章列表
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/chapter/listForClient", p, c)
  },
  degree_chapter_listSimple: {
    /*
     * 简易列表
     * ableStatus 启用禁用 (string query )
     * courseId 课程id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/chapter/listSimple", p, c)
  },
  degree_course: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * category 分类(试听课用) (string query )
     * code 课程代码 (string query )
     * cover 封面 (string query )
     * id  (integer query )
     * name 课程名字 (string query )
     * teacher 授课老师(试听课用) (string query )
     * type 课程类型：专业课|必修课|试听课 (string query )
     * videoResourceId 视频资源ID(试听课用) (integer query )
     */
    post: (p, c) => $.post("/api/cms/exemption/degree/course", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/exemption/degree/course", p, c)
  },
  degree_course_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/course/export", p, c)
  },
  degree_course_exportForFree: {
    /*
     * 导出-试听课
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/course/exportForFree", p, c)
  },
  degree_course_getIdByName: {
    /*
     * 根据名称获取id
     * name 课程名字 (string query )
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/course/getIdByName", p, c)
  },
  degree_course_list: {
    /*
     * 列表-精品课
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/course/list", p, c)
  },
  degree_course_listForClient: {
    /*
     * 免试专升本课程C端口列表
     * type 类型：必修课|专业课 (string query )
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/course/listForClient", p, c)
  },
  degree_course_listForFree: {
    /*
     * 列表-试听课
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/course/listForFree", p, c)
  },
  degree_course_listFreeCourseForClient: {
    /*
     * 免试专升本-免费试听课C端口列表
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/course/listFreeCourseForClient", p, c)
  },
  degree_course_listSimple: {
    /*
     * 简易课程列表
     * ableStatus 启用禁用 (string query )
     * types 类型 (array query )
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/course/listSimple", p, c)
  },
  degree_liveCourse: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * courseId 课程id (integer query )
     * cover 封面 (string query )
     * endTime 结束时间 (string query )
     * id  (integer query )
     * liveUrl 直播地址 (string query )
     * note 注意事项 (string query )
     * startTime 开始时间 (string query )
     * teacher 老师 (string query )
     * teacherAvatar 老师头像 (string query )
     * teacherSummary 老师简介 (string query )
     * title 标题 (string query )
     * type 类型公开课等 (string query )
     * videoUrl 回放地址 (string query )
     */
    post: (p, c) => $.post("/api/cms/exemption/degree/liveCourse", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/exemption/degree/liveCourse", p, c)
  },
  degree_liveCourse_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/liveCourse/export", p, c)
  },
  degree_liveCourse_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/liveCourse/list", p, c)
  },
  degree_liveCourse_listForClient: {
    /*
     * 直播课C端口列表, 带分页
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/liveCourse/listForClient", p, c)
  },
  degree_liveCourse_listLatestForClient: {
    /*
     * 最近的直播课C端口列表
     * limitCount id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/liveCourse/listLatestForClient", p, c)
  },
  degree_paper: {
    /*
     * 添加
     * ableStatus 启用状态：启用，禁用 (string query )
     * belongId 归属id,模拟测试、历年真题为课程id,阶段小测、章节作业为章节id (integer query )
     * content 内容 (string query )
     * duration 建议答题时长 (string query )
     * id  (integer query )
     * name 试卷名称 (string query )
     * subjectCount 习题数量 (integer query )
     * type 类型:模拟测试、历年真题、阶段小测、章节作业 (string query )
     */
    post: (p, c) => $.post("/api/cms/exemption/degree/paper", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/exemption/degree/paper", p, c)
  },
  degree_paper_content: {
    /*
     * 查看试卷内容
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/paper/content", p, c)
  },
  degree_paper_contentForStatistics: {
    /*
     * 获取试卷分析
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/paper/contentForStatistics", p, c)
  },
  degree_paper_createPaperContent: {
    /*
     * 生成试卷内容
     * paperId 试卷id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/cms/exemption/degree/paper/createPaperContent", p, c)
  },
  degree_paper_listChapterWork: {
    /*
     * 章节作业列表
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/paper/listChapterWork", p, c)
  },
  degree_paper_listEntryExam: {
    /*
     * 入门测试列表
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/paper/listEntryExam", p, c)
  },
  degree_paper_listEntryExamForClient: {
    /*
     * 入门测试列表-C端
     * phone 输入线索二维码填写的手机号 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/paper/listEntryExamForClient", p, c)
  },
  degree_paper_listMockExam: {
    /*
     * 模拟测试列表
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/paper/listMockExam", p, c)
  },
  degree_paper_listMockExamForClient: {
    /*
     * 模拟测试列表-C端
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/paper/listMockExamForClient", p, c)
  },
  degree_paper_listReal: {
    /*
     * 历年真题列表
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/paper/listReal", p, c)
  },
  degree_paper_listRealForClient: {
    /*
     * 历年真题列表-C端
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/paper/listRealForClient", p, c)
  },
  degree_paper_listSimple: {
    /*
     * 简易试卷列表
     * ableStatus ableStatus (string query )
     * type type (string query required)
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/paper/listSimple", p, c)
  },
  degree_paper_listStage: {
    /*
     * 题库练习列表
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/paper/listStage", p, c)
  },
  degree_paper_listStageQuiz: {
    /*
     * 阶段小测列表
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/paper/listStageQuiz", p, c)
  },
  degree_paper_uploadPaperSubjectByExcel: {
    /*
     * 上传试卷习题(Excel), 生成试卷内容
     * courseId 课程id (integer query required)
     * file file (file formData required)
     * paperId 试卷id (integer query required)
     * type 类型：题库练习|章节作业|阶段小测|入门测试|模拟测试|历年真题 (string query required)
     */
    post: (p, c) =>
      $.post("/api/cms/exemption/degree/paper/uploadPaperSubjectByExcel", p, c)
  },
  degree_section: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * chapterId 大章id (integer query )
     * fileUrl 附件地址 (string query )
     * id  (integer query )
     * name 小节名字 (string query )
     * sort 排序 (integer query )
     * videoResourceId 视频资源ID (integer query )
     */
    post: (p, c) => $.post("/api/cms/exemption/degree/section", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/exemption/degree/section", p, c)
  },
  degree_section_list: {
    /*
     * 列表
     * ableStatus 启用禁用 (string query )
     * chapterId 章ID (integer query required)
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/section/list", p, c)
  },
  degree_subject: {
    /*
     * 添加习题
     * ableStatus 启用状态：启用，禁用 (string query )
     * analysis 解析 (string query )
     * answer 正确答案 (string query )
     * answerA 答案A (string query )
     * answerB 答案B (string query )
     * answerC 答案C (string query )
     * answerD 答案D (string query )
     * answerE 答案E (string query )
     * answerF 答案F (string query )
     * chapterId 习题章节id (integer query )
     * content 题目 (string query )
     * contentId 内容id (integer query )
     * contentType 内容类型：单选，多选，判断等 (string query )
     * courseId 课程id (integer query )
     * hashText  (string query )
     * id  (integer query )
     * level 难度:简单,一般,难 (string query )
     * logicType 逻辑题型:单选，多选，判断，填空 (string query )
     * remark 备注 (string query )
     * score 分值 (number query )
     * sort 习题序号 (integer query )
     */
    post: (p, c) => $.post("/api/cms/exemption/degree/subject", p, c),

    /*
     * 编辑习题
     * ableStatus 启用状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=启用状态 (string query )
     * analysis 解析|列表||| (string query )
     * answer 正确答案|列表||| (string query )
     * answerA 答案A|列表||| (string query )
     * answerB 答案B|列表||| (string query )
     * answerC 答案C|列表||| (string query )
     * answerD 答案D|列表||| (string query )
     * answerE 答案E|列表||| (string query )
     * answerF 答案F|列表||| (string query )
     * content 题目|列表||| (string query )
     * contentContent 内容|列表||| (string query )
     * contentId 内容编号|全部|| (string query )
     * contentType 内容类型|列表||| (string query )
     * id 习题编号|全部||| (integer query )
     * level 难度|列表||| (string query )
     * logicType 逻辑类型|全部||字符串下拉|api/bms/develop/config/listSelect?key=逻辑题型 (string query )
     * remark 备注|全部||| (string query )
     * score 分值|列表||| (number query )
     * sort 习题序号|列表||| (integer query )
     */
    put: (p, c) => $.put("/api/cms/exemption/degree/subject", p, c)
  },
  degree_subject_collectionAddForClient: {
    /*
     * c端收藏
     * subjectId 习题id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/cms/exemption/degree/subject/collection/addForClient", p, c)
  },
  degree_subject_collectionExport: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/subject/collection/export", p, c)
  },
  degree_subject_collectionList: {
    /*
     * 习题收藏列表
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/subject/collection/list", p, c)
  },
  degree_subject_collectionListSubjectForClient: {
    /*
     * c端学生收藏的习题列表-分页
     */
    get: (p, c) =>
      $.get(
        "/api/cms/exemption/degree/subject/collection/listSubjectForClient",
        p,
        c
      )
  },
  degree_subject_collectionRemoveForClient: {
    /*
     * c端取消收藏
     * subjectId 习题id (integer query required)
     */
    delete: (p, c) =>
      $.delete(
        "/api/cms/exemption/degree/subject/collection/removeForClient",
        p,
        c
      )
  },
  degree_subject_details: {
    /*
     * 习题详情
     * id 习题id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/subject/details", p, c)
  },
  degree_subject_entryExerciseInfoForClient: {
    /*
     * C端练习信息-入门测试专用
     * belongId 归属id (integer query required)
     * exerciseId 练习id (integer query )
     * userId userId (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/exemption/degree/subject/entryExerciseInfoForClient",
        p,
        c
      )
  },
  degree_subject_exerciseInfo: {
    /*
     * 练习信息（阶段小测、章节作业、入门测试）
     * belongId 归属id (integer query required)
     * exerciseId 练习id (integer query )
     * type 类型：阶段小测、章节作业、入门测试 (string query required)
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/subject/exerciseInfo", p, c)
  },
  degree_subject_exerciseInfoForClient: {
    /*
     * C端练习信息
     * belongId 归属id (integer query required)
     * exerciseId 练习id (integer query )
     * type 类型：章节作业，模拟测试，阶段小测，历年真题 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/subject/exerciseInfoForClient", p, c)
  },
  degree_subject_export: {
    /*
     * 导出习题
     * chapterId 章节id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/subject/export", p, c)
  },
  degree_subject_exportByKey: {
    /*
     * 导出，爬虫用-临时方法
     * key 保存key，导出需用这个key (string query required)
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/subject/exportByKey", p, c)
  },
  degree_subject_infoForStore: {
    /*
     * 习题信息-题库练习
     * id 习题id (integer query required)
     * paperId 试卷id (integer query )
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/subject/infoForStore", p, c)
  },
  degree_subject_infoForStoreForClient: {
    /*
     * C端习题信息-题库练习
     * id 习题id (integer query required)
     * paperId 试卷id (integer query )
     * withAnswer 是否查看答题记录 1是 0 否 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/subject/infoForStoreForClient", p, c)
  },
  degree_subject_list: {
    /*
     * 列表
     * chapterId 章节id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/subject/list", p, c)
  },
  degree_subject_listByPaper: {
    /*
     * 根据试卷ID取章节习题列表（入门测试）
     * ableStatus 启用禁用 (string query )
     * contentType 内容类型 (string query )
     * paperId 试卷id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/subject/listByPaper", p, c)
  },
  degree_subject_listRandomSubjectForClient: {
    /*
     * c端题库随机刷题
     * maxCount 题目数量 (integer query required)
     * paperId 题库练习paperId (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/exemption/degree/subject/listRandomSubjectForClient",
        p,
        c
      )
  },
  degree_subject_parseSubject: {
    /*
     * 解析习题，爬虫用-临时方法
     * clearOrigin 是否删除key保存的原内容 (boolean query required)
     * content 习题json内容 (string query required)
     * key 保存key，导出需用这个key (string query required)
     */
    post: (p, c) =>
      $.post("/api/cms/exemption/degree/subject/parseSubject", p, c)
  },
  degree_subject_subjectPerForClient: {
    /*
     * C端题库刷题进度
     * paperId 题库练习paperId (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/subject/subjectPerForClient", p, c)
  },
  degree_subject_uploadByWord: {
    /*
     * 上传章节习题(Word)
     * chapterId 大章id (integer query )
     * courseId 课程id (integer query required)
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post("/api/cms/exemption/degree/subject/uploadByWord", p, c)
  },
  degree_subject_wrongBatchAddForClient: {
    /*
     * 批量添加错题
     * answers 答案 (array query required)
     * subjectIds 习题id (array query required)
     */
    post: (p, c) =>
      $.post("/api/cms/exemption/degree/subject/wrong/batchAddForClient", p, c)
  },
  degree_subject_wrongDetailsForClient: {
    /*
     * 详情
     * subjectId 习题id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/degree/subject/wrong/detailsForClient", p, c)
  },
  degree_subject_wrongExport: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/subject/wrong/export", p, c)
  },
  degree_subject_wrongList: {
    /*
     * 错题集列表
     */
    get: (p, c) => $.get("/api/cms/exemption/degree/subject/wrong/list", p, c)
  },
  degree_subject_wrongListSubjectForClient: {
    /*
     * 错题集习题列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/exemption/degree/subject/wrong/listSubjectForClient",
        p,
        c
      )
  },
  degree_subject_wrongRemoveForClient: {
    /*
     * 移除
     * subjectId 习题id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/exemption/degree/subject/wrong/removeForClient", p, c)
  },

  /**
   * 免试专升本-资讯公告
   */
  exemption_degree_notice: {
    /*
     * 添加编辑(添加类型:公告|资讯|banner, 为banner时, 只需要传cover, publishStatus为已发布
     * content 正文 (string query )
     * cover 封面 (string query )
     * creatorId 创建人 (integer query )
     * id  (integer query )
     * publishStatus 发布状态 (string query )
     * publishTime 发布时间 (string query )
     * title 标题 (string query )
     * type 类型:公告|资讯|banner (string query )
     */
    post: (p, c) => $.post("/api/cms/exemption/exemption/degree/notice", p, c)
  },
  exemption_degree_noticeGetDetails: {
    /*
     * 详情
     * id id (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/exemption/degree/notice/getDetails", p, c)
  },
  exemption_degree_noticeListForBanner: {
    /*
     * banner列表
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/exemption/degree/notice/listForBanner", p, c)
  },
  exemption_degree_noticeListForNews: {
    /*
     * 新闻资讯列表
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/exemption/degree/notice/listForNews", p, c)
  },
  exemption_degree_noticeListForNotice: {
    /*
     * 公告列表
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/exemption/degree/notice/listForNotice", p, c)
  },
  exemption_degree_noticeListLatestNoticeForClient: {
    /*
     * 最新的公告|资讯|banner列表, 取几条自己传
     * limitCount 取多少条 (integer query required)
     * type 类型:公告|资讯|banner (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/exemption/exemption/degree/notice/listLatestNoticeForClient",
        p,
        c
      )
  },
  exemption_degree_noticeListNoticeForClient: {
    /*
     * 公告|资讯|banner列表
     * type 类型:公告|资讯|banner (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/exemption/exemption/degree/notice/listNoticeForClient",
        p,
        c
      )
  },
  exemption_degree_noticePublish: {
    /*
     * 发布
     * id id (integer query required)
     * publishStatus 发布状态 (string query required)
     */
    post: (p, c) =>
      $.post("/api/cms/exemption/exemption/degree/notice/publish", p, c)
  },
  exemption_degree_noticeRemove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/exemption/exemption/degree/notice/remove", p, c)
  },

  /**
   * 学生请假
   */
  studentAbsence_applyForClient: {
    /*
     * C端提交请假
     * endTime 开始时间 (string query required)
     * extraFileUrl 附件 (string query )
     * reason 请假理由 (string query required)
     * startTime 开始时间 (string query required)
     * type 请假类型 (string query required)
     */
    post: (p, c) =>
      $.post("/api/cms/exemption/studentAbsence/applyForClient", p, c)
  },
  studentAbsence_audit: {
    /*
     * 班主任审批
     * auditRemark 审核备注 (string query )
     * id id (integer query required)
     * status 状态 (string query required)
     */
    post: (p, c) => $.post("/api/cms/exemption/studentAbsence/audit", p, c)
  },
  studentAbsence_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/exemption/studentAbsence/details", p, c)
  },
  studentAbsence_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/exemption/studentAbsence/export", p, c)
  },
  studentAbsence_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/exemption/studentAbsence/list", p, c)
  },
  studentAbsence_listForClient: {
    /*
     * C端请假记录
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/studentAbsence/listForClient", p, c)
  },
  studentAbsence_listForClientByTeacher: {
    /*
     * C端请假记录(小程序班主任查看)
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/exemption/studentAbsence/listForClientByTeacher", p, c)
  }
};
